/**
 * Реестр недавних локальных действий с маршрутами (EDS-5111).
 *
 * Когда диспетчер сам выполняет действие над маршрутом (например, «Завершить»),
 * компонент сразу показывает локальный тост. Следом по Centrifugo прилетает CDC
 * route_updated с тем же сообщением — для автора это дубль. Помечаем маршрут как
 * «изменён локально», и обработчик CDC гасит свой тост только на клиенте автора;
 * другие диспетчеры и liveupdate-изменения метки не имеют и тост получают.
 */
const acted = new Map()
const TTL_MS = 15000

/** Помечает маршрут как только что изменённый локально этим клиентом. */
export function markLocalRouteAction(routeId) {
    if (routeId) acted.set(String(routeId), Date.now())
}

/**
 * Возвращает true, если маршрут был изменён локально в пределах TTL, и снимает
 * метку (одноразовая — гасит ровно один CDC-эхо-тост).
 */
export function wasLocalRouteAction(routeId) {
    const key = String(routeId)
    const ts = acted.get(key)
    if (!ts) return false
    acted.delete(key)
    return Date.now() - ts < TTL_MS
}
